module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [_c('div', {
    staticClass: "bg-light lter b-b wrapper-md"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [(_vm.lote.id) ? _c('router-link', {
    staticClass: "pull-right hidden-print",
    staticStyle: {
      "clear": "left"
    },
    attrs: {
      "to": {
        name: 'lotes.visualizar',
        params: {
          leilao: _vm.lote.leilao,
          id: _vm.lote.id
        }
      }
    }
  }, [_c('strong', {
    staticClass: "label no-radius bg-info"
  }, [_vm._v("Voltar")]), _vm._v("\n              para o lote\n            ")]) : _c('router-link', {
    staticClass: "pull-right hidden-print",
    staticStyle: {
      "clear": "left"
    },
    attrs: {
      "to": {
        name: 'leiloes.visualizar',
        params: {
          id: _vm.lote.leilao
        }
      }
    }
  }, [_c('strong', {
    staticClass: "label no-radius bg-info"
  }, [_vm._v("Voltar")]), _vm._v("\n              para a tela do leilão\n            ")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "wrapper-md"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [(_vm.cadastroError !== null) ? _c('div', {
    ref: "error",
    staticClass: "alert alert-danger",
    attrs: {
      "tabindex": "-1"
    }
  }, [_c('div', {
    staticClass: "m-b-sm font-bold"
  }, [_vm._v("Erro ao registrar o leilão, corrija e tente novamente")]), _vm._v(" "), _vm._l((_vm.cadastroError), function(erro, key) {
    return _c('p', [_vm._v(_vm._s(_vm.printError(erro)))])
  })], 2) : _vm._e(), _vm._v(" "), _c('a', {
    ref: "sucessMsg",
    attrs: {
      "name": "sucessMsg",
      "id": "sucessMsg",
      "href": "javascript:void(0)"
    }
  }), _vm._v(" "), (_vm.atualizadoSucesso !== null) ? _c('div', {
    ref: "error",
    staticClass: "alert alert-success",
    attrs: {
      "tabindex": "-1"
    }
  }, [_c('div', {
    staticClass: "font-bold"
  }, [_vm._v("Atualizado com sucesso!")])]) : _vm._e(), _vm._v(" "), _c('form', {
    staticClass: "bs-example form-horizontal",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "clearfix"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-lg-2 control-label"
  }, [_vm._v("Número")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.lote.numero),
      expression: "lote.numero"
    }],
    staticClass: "form-control w-auto",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.lote.numero)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.lote, "numero", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-lg-2 control-label"
  }, [_vm._v("GRV")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-10",
    staticStyle: {
      "display": "flex",
      "flex-direction": "row",
      "align-items": "baseline"
    }
  }, [_c('div', {
    staticClass: "input-checa-grv-lote"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.grv.numero),
      expression: "grv.numero",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control w-auto",
    class: {
      'input-checa-grv-lote-erro': _vm.grv.isOk === false,
        'input-checa-grv-lote-ok': _vm.grv.isOk === true
    },
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.grv.numero)
    },
    on: {
      "keyup": _vm.checarNumeroGrv,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.grv, "numero", $event.target.value.trim())
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), (_vm.grv.isOk === true) ? _c('i', {
    staticClass: "fa fa-check text-success"
  }) : _vm._e(), _vm._v(" "), (_vm.grv.isOk === -1) ? _c('i', {
    staticClass: "fa fa-spinner fa-spin"
  }) : _vm._e(), _vm._v(" "), (_vm.grv.isOk === false) ? _c('i', {
    staticClass: "fa fa-times text-danger"
  }) : _vm._e(), _vm._v(" "), (_vm.grv.isOk === false) ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" " + _vm._s(_vm.mensagemErroConsulta) + " ")]) : _vm._e()]), _vm._v(" "), _c('u-button', {
    staticClass: "btn btn-sm btn-success m-l-xs",
    attrs: {
      "type": "button",
      "disabled": !_vm.lote.grv
    },
    on: {
      "click": _vm.openHistoricoLeiloesViewer
    }
  }, [_c('i', {
    staticClass: "fa fa-gavel"
  }), _vm._v("  Ver histórico de leilões\n                      ")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-lg-2 control-label"
  }, [_vm._v("Título")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.lote.titulo),
      expression: "lote.titulo"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.lote.titulo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.lote, "titulo", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-lg-2 control-label"
  }, [_vm._v("Descrição")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-10"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.lote.descricao),
      expression: "lote.descricao"
    }],
    staticClass: "form-control",
    staticStyle: {
      "resize": "none"
    },
    attrs: {
      "rows": "3"
    },
    domProps: {
      "value": (_vm.lote.descricao)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.lote, "descricao", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-lg-2 control-label"
  }, [_vm._v("Valor inicial")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-10"
  }, [_c('input', {
    directives: [{
      name: "money",
      rawName: "v-money",
      value: (_vm.money),
      expression: "money"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.valorInicial),
      expression: "valorInicial"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "R$ 0,00"
    },
    domProps: {
      "value": (_vm.valorInicial)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.valorInicial = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-lg-2 control-label"
  }, [_vm._v("Destaque")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-10"
  }, [_c('label', {
    staticClass: "i-switch bg-success m-t-xs m-r"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.lote.destaque),
      expression: "lote.destaque"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.lote.destaque) ? _vm._i(_vm.lote.destaque, null) > -1 : (_vm.lote.destaque)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.lote.destaque,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.lote, "destaque", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.lote, "destaque", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.lote, "destaque", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('i')])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-lg-2 control-label"
  }, [_vm._v("Observação")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-10"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.lote.observacao),
      expression: "lote.observacao"
    }],
    staticClass: "form-control",
    staticStyle: {
      "resize": "none"
    },
    attrs: {
      "rows": "3"
    },
    domProps: {
      "value": (_vm.lote.observacao)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.lote, "observacao", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-lg-2 control-label"
  }, [_vm._v("Título Tela Pregoeiro")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.lote.tituloPregoeiro),
      expression: "lote.tituloPregoeiro"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.lote.tituloPregoeiro)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.lote, "tituloPregoeiro", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-lg-2 control-label"
  }, [_vm._v("Descrição Tela Pregoeiro")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-10"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.lote.descricaoPregoeiro),
      expression: "lote.descricaoPregoeiro"
    }],
    staticClass: "form-control",
    staticStyle: {
      "resize": "none"
    },
    attrs: {
      "rows": "3"
    },
    domProps: {
      "value": (_vm.lote.descricaoPregoeiro)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.lote, "descricaoPregoeiro", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-lg-2 control-label"
  }, [_vm._v("Observação Tela Pregoeiro")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-10"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.lote.observacaoPregoeiro),
      expression: "lote.observacaoPregoeiro"
    }],
    staticClass: "form-control",
    staticStyle: {
      "resize": "none"
    },
    attrs: {
      "rows": "3"
    },
    domProps: {
      "value": (_vm.lote.observacaoPregoeiro)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.lote, "observacaoPregoeiro", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 text-center"
  }, [_c('a', {
    staticClass: "card1"
  }, [_c('div', {
    staticClass: "p-item lote-item-status1"
  }, [_c('div', {
    staticClass: "cont-img-destaque"
  }, [_c('span', [_vm._v(_vm._s(_vm.lote.numero ? '000'.substring(0, 3 - String(_vm.lote.numero).length) + String(_vm.lote.numero) : '000'))]), _vm._v(" "), (_vm.lote.urlMin) ? _c('div', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "width": "226",
      "height": "169",
      "src": _vm.lote.urlMin
    }
  })]) : _c('div', {
    staticClass: "img"
  }, [_vm._v("Imagem")])]), _vm._v(" "), _c('div', {
    staticClass: "cont-info-destaque"
  }, [_c('h3', [_vm._v("\n                          " + _vm._s(_vm.lote.titulo) + "\n                        ")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.lote.descricao))]), _vm._v(" "), (_vm.lote.valorInicial) ? _c('p', {
    staticClass: "minimo"
  }, [_vm._v("R$ " + _vm._s(_vm.lote.valorInicial))]) : _vm._e()])])])])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [(_vm.ACL.check('adm_alterar_status_lote', this.currentUser.id)) ? _c('select-estado-geral', {
    attrs: {
      "value": _vm.lote.estadoLote
    },
    model: {
      value: (_vm.lote.estadoLote),
      callback: function($$v) {
        _vm.$set(_vm.lote, "estadoLote", $$v)
      },
      expression: "lote.estadoLote"
    }
  }) : _vm._e(), _vm._v(" "), _c('select-situacao-veiculo', {
    attrs: {
      "value": _vm.lote.situacaoVeiculo
    },
    model: {
      value: (_vm.lote.situacaoVeiculo),
      callback: function($$v) {
        _vm.$set(_vm.lote, "situacaoVeiculo", $$v)
      },
      expression: "lote.situacaoVeiculo"
    }
  })], 1)]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-lg-2 control-label"
  }, [_vm._v("Placa")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.lote.placa),
      expression: "lote.placa"
    }],
    staticClass: "form-control w-auto",
    attrs: {
      "type": "text",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.lote.placa)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.lote, "placa", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-lg-2 control-label"
  }, [_vm._v("Chassi")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.lote.chassi),
      expression: "lote.chassi"
    }],
    staticClass: "form-control w-auto",
    attrs: {
      "type": "text",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.lote.chassi)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.lote, "chassi", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-lg-2 control-label"
  }, [_vm._v("Renavam")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.lote.renavam),
      expression: "lote.renavam"
    }],
    staticClass: "form-control w-auto",
    attrs: {
      "type": "text",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.lote.renavam)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.lote, "renavam", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-lg-2 control-label"
  }, [_vm._v("Cor")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.lote.cor),
      expression: "lote.cor"
    }],
    staticClass: "form-control w-auto",
    attrs: {
      "type": "text",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.lote.cor)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.lote, "cor", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-lg-2 control-label"
  }, [_vm._v("Número do Motor")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.lote.numeroMotor),
      expression: "lote.numeroMotor"
    }],
    staticClass: "form-control w-auto",
    attrs: {
      "type": "text",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.lote.numeroMotor)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.lote, "numeroMotor", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-lg-2 control-label"
  }, [_vm._v("Condições")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-10"
  }, [_c('u-button-group', {
    attrs: {
      "options": _vm.condicoesLote
    },
    model: {
      value: (_vm.lote.condicao),
      callback: function($$v) {
        _vm.$set(_vm.lote, "condicao", $$v)
      },
      expression: "lote.condicao"
    }
  })], 1)]), _vm._v(" "), _c('select-comitente', {
    ref: "comitentes",
    attrs: {
      "value": _vm.lote.comitente
    },
    model: {
      value: (_vm.lote.comitente),
      callback: function($$v) {
        _vm.$set(_vm.lote, "comitente", $$v)
      },
      expression: "lote.comitente"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-lg-2 control-label"
  }, [_vm._v("Tipo de Bem")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-10"
  }, [_c('select-tipo-bem', {
    on: {
      "atualizaCamposTipoBem": _vm.atualizaCamposTipoBem
    },
    model: {
      value: (_vm.lote.tipo),
      callback: function($$v) {
        _vm.$set(_vm.lote, "tipo", $$v)
      },
      expression: "lote.tipo"
    }
  })], 1)]), _vm._v(" "), _c('tipo-bem-campos', {
    ref: "tipoBemCampos",
    attrs: {
      "value": _vm.lote.tipoCampos
    },
    on: {
      "updateTipoBemCampos": _vm.setValuesInTipoBemCampos
    },
    model: {
      value: (_vm.lote.tipoCampos),
      callback: function($$v) {
        _vm.$set(_vm.lote, "tipoCampos", $$v)
      },
      expression: "lote.tipoCampos"
    }
  }), _vm._v(" "), _c('select-marca', {
    ref: "marcas",
    attrs: {
      "value": _vm.lote.marca
    },
    on: {
      "atualizaMarca": _vm.atualizaMarca
    },
    model: {
      value: (_vm.lote.marca),
      callback: function($$v) {
        _vm.$set(_vm.lote, "marca", $$v)
      },
      expression: "lote.marca"
    }
  }), _vm._v(" "), _c('select-modelo', {
    ref: "modelos",
    attrs: {
      "value": _vm.lote.modelo.modelo
    },
    model: {
      value: (_vm.lote.modelo.modelo),
      callback: function($$v) {
        _vm.$set(_vm.lote.modelo, "modelo", $$v)
      },
      expression: "lote.modelo.modelo"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-lg-2 control-label"
  }, [_vm._v("Ano Fabricação")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.lote.modelo.anoFabricacao),
      expression: "lote.modelo.anoFabricacao"
    }],
    staticClass: "form-control w-auto",
    attrs: {
      "type": "text",
      "placeholder": "",
      "size": "10"
    },
    domProps: {
      "value": (_vm.lote.modelo.anoFabricacao)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.lote.modelo, "anoFabricacao", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-lg-2 control-label"
  }, [_vm._v("Ano Modelo")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.lote.modelo.anoModelo),
      expression: "lote.modelo.anoModelo"
    }],
    staticClass: "form-control w-auto",
    attrs: {
      "type": "text",
      "placeholder": "",
      "size": "10"
    },
    domProps: {
      "value": (_vm.lote.modelo.anoModelo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.lote.modelo, "anoModelo", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-lg-2 control-label"
  }, [_vm._v("Depósito")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.lote.deposito),
      expression: "lote.deposito"
    }],
    staticClass: "form-control w-auto",
    attrs: {
      "type": "text",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.lote.deposito)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.lote, "deposito", $event.target.value)
      }
    }
  })])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-lg-2 control-label"
  }, [_vm._v("Taxa de Arremate")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.valorTaxaArremate),
      expression: "valorTaxaArremate"
    }, {
      name: "money",
      rawName: "v-money",
      value: (_vm.money),
      expression: "money"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "R$ 0,00"
    },
    domProps: {
      "value": (_vm.valorTaxaArremate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.valorTaxaArremate = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-lg-2 control-label"
  }, [_vm._v("Tabela Fipe")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.valorTabelaFipe),
      expression: "valorTabelaFipe"
    }, {
      name: "money",
      rawName: "v-money",
      value: (_vm.money),
      expression: "money"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "R$ 0,00"
    },
    domProps: {
      "value": (_vm.valorTabelaFipe)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.valorTabelaFipe = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-lg-2 control-label"
  }, [_vm._v("Avaliação")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.valorAvaliacao),
      expression: "valorAvaliacao"
    }, {
      name: "money",
      rawName: "v-money",
      value: (_vm.money),
      expression: "money"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "R$ 0,00"
    },
    domProps: {
      "value": (_vm.valorAvaliacao)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.valorAvaliacao = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-lg-2 control-label"
  }, [_vm._v("Incremento")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.valorIncremento),
      expression: "valorIncremento"
    }, {
      name: "money",
      rawName: "v-money",
      value: (_vm.money),
      expression: "money"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "R$ 0,00"
    },
    domProps: {
      "value": (_vm.valorIncremento)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.valorIncremento = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-lg-2 control-label"
  }, [_vm._v("Valor Inicial")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.valorInicial),
      expression: "valorInicial"
    }, {
      name: "money",
      rawName: "v-money",
      value: (_vm.money),
      expression: "money"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "R$ 0,00"
    },
    domProps: {
      "value": (_vm.valorInicial)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.valorInicial = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-lg-2 control-label"
  }, [_vm._v("Mínimo")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.valorMinimo),
      expression: "valorMinimo"
    }, {
      name: "money",
      rawName: "v-money",
      value: (_vm.money),
      expression: "money"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "R$ 0,00"
    },
    domProps: {
      "value": (_vm.valorMinimo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.valorMinimo = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-lg-2 control-label"
  }, [_vm._v("Meta")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.valorMeta),
      expression: "valorMeta"
    }, {
      name: "money",
      rawName: "v-money",
      value: (_vm.money),
      expression: "money"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "R$ 0,00"
    },
    domProps: {
      "value": (_vm.valorMeta)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.valorMeta = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-lg-2 control-label"
  }, [_vm._v("Custo Remoção")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.valorRemocao),
      expression: "valorRemocao"
    }, {
      name: "money",
      rawName: "v-money",
      value: (_vm.money),
      expression: "money"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "R$ 0,00"
    },
    domProps: {
      "value": (_vm.valorRemocao)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.valorRemocao = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-lg-2 control-label"
  }, [_vm._v("ICMS %")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.lote.valorIcms),
      expression: "lote.valorIcms"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "placeholder": "%"
    },
    domProps: {
      "value": (_vm.lote.valorIcms)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.lote, "valorIcms", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-lg-2 control-label"
  }, [_vm._v("ISS %")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.lote.valorIss),
      expression: "lote.valorIss"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "placeholder": "%"
    },
    domProps: {
      "value": (_vm.lote.valorIss)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.lote, "valorIss", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "row wrapper"
  }, [_c('u-button', {
    staticClass: "btn m-b-xs w-xs btn-info m-r-xs",
    attrs: {
      "disabled": _vm.grv.isOk === false
    },
    on: {
      "click": _vm.submit
    }
  }, [(!_vm.lote.id) ? _c('span', [_vm._v("Cadastrar")]) : _vm._e(), _vm._v(" "), (_vm.lote.id) ? _c('span', [_vm._v("Atualizar")]) : _vm._e()]), _vm._v(" "), _c('u-button', {
    staticClass: "btn m-b-xs w-xs m-r-xs btn-default"
  }, [_vm._v("Cancelar")]), _vm._v(" "), (!_vm.lote.id) ? _c('span', [_vm._v("Ao cadastrar, o status do lote será "), _c('span', {
    staticClass: "text-info"
  }, [_vm._v("Rascunho")]), _vm._v(", para publicá-lo, altere o status após o cadastro.")]) : _vm._e()], 1)]), _vm._v(" "), (_vm.showHistoricoLeiloes) ? _c('popup-viewer', {
    on: {
      "close": _vm.closeHistoricoLeiloesViewer
    }
  }, [_c('HistoricoLeiloesGrv', {
    attrs: {
      "grvId": _vm.lote.grv
    }
  })], 1) : _vm._e()], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-6"
  }, [_c('h1', {
    staticClass: "m-n font-thin h3"
  }, [_vm._v("Cadastro de Lote")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2637236a","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/website/leiloes/components/NovoLote.vue
// module id = 1565
// module chunks = 17